module.exports = __webpack_public_path__ + "img/user29.b3a1fe54.jpg";